export default __webpack_public_path__ + "b6e6730d8c52292d9302489d51f56db5.png";